"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lane_open = exports.lane_closed = exports.iconLarge = exports.SHIELD_WIDTHS = void 0;
var iconLarge = {
  width: 54,
  height: 54
};
exports.iconLarge = iconLarge;
var SHIELD_WIDTHS = [54, 54, 64, 80, 82];
exports.SHIELD_WIDTHS = SHIELD_WIDTHS;
var lane_open = "rgba(20, 219, 139, 1)";
exports.lane_open = lane_open;
var lane_closed = "rgba(240, 73, 73, 1)";
exports.lane_closed = lane_closed;